// @flow
import React from 'react';
import {View, StyleSheet, Platform} from 'react-native';
import {FullButton, GradientPage} from '../../common';
import InstallEsimButton from '../../signUp/InstallEsimButton';
import I18n from '../../../lib/i18n';

const styles = StyleSheet.create({
  button: {
    marginHorizontal: 20,
  },
  buttonContainer: {
    flex: 1,
  },
  container: {
    flex: 1,
    justifyContent: 'space-around',
  },
  contentContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 2,
  },
});

export const ResultPage = (props: Props) => {
  const {
    buttonText,
    children,
    handleButtonPress,
    resultContent,
    withGradient,
    eSimSelected,
    isLoading,
    hasError,
    actionType,
  } = props;
  const WrapperView = withGradient ? GradientPage : View;

  return (
    <WrapperView testID={props.testID ?? 'paymentSuccess-screen'} style={styles.container} iosEdges={['top','bottom']}>
      <View style={styles.contentContainer}>{resultContent}</View>
      <View style={styles.buttonContainer}>
        {!hasError && eSimSelected && Platform.OS !== 'web' && (
          <InstallEsimButton
            installEsimText={I18n.t('SignUp.FinalPage.installEsim')}
            installEsimAction={handleButtonPress}
            goToMailBoxText={I18n.t('SignUp.FinalPage.goToMailbox')}
            isLoading={isLoading}
          />
        )}

        {!hasError &&
          !eSimSelected &&
          Platform.OS !== 'web' &&
          actionType !== 'suspendLine' && (
            <FullButton
              style={styles.button}
              onPress={handleButtonPress}
              text={buttonText}
              isLoading={isLoading}
            />
          )}

          {hasError && (
            <FullButton
              style={styles.button}
              onPress={handleButtonPress}
              text={buttonText}
              isLoading={isLoading}
            />
          )}
        {children}
      </View>
    </WrapperView>
  );
};

type Props = {
  buttonText: string,
  children?: any,
  handleButtonPress?: () => void,
  resultContent: any,
  withGradient?: boolean,
  isLoading?: boolean,
  hasError: boolean,
  actionType: string,
};
